Ext.define('SA.view.TableSectionRenderer', {
    constructor({sectionId, sectionCmp, scrollFillerCmp, scrollFrameEl, cellDelegate}) {
        this.sectionId = sectionId;
        this.sectionCmp = sectionCmp;
        this.scrollFillerCmp = scrollFillerCmp;
        this.scrollFrameEl = scrollFrameEl;
        this.cellDelegate = cellDelegate;
    },

    render({dragColId, trackContentSizes, containerSize, scrollFillerSize, scrollFrameOffset, scrollFrameTrackIds: {rowIds, colIds}}) {
        this.sectionCmp.setSize(containerSize);
        this.scrollFillerCmp.setSize(scrollFillerSize);
        this.scrollFrameEl.style.margin = `${scrollFrameOffset.top}px 0 0 ${scrollFrameOffset.left}px`;
        this.setScrollFrameTrackCounts({rowCount: rowIds.length, colCount: colIds.length});
        this.renderScrollFrameCells({dragColId, trackContentSizes, rowIds, colIds});
    },

    renderScrollFrameCells({dragColId, trackContentSizes, rowIds, colIds}) {
        var sectionId = this.sectionId;

        Array.from(this.scrollFrameEl.rows).forEach((row, rowIdx) => {
            var rowId = rowIds[rowIdx];

            Array.from(row.cells).forEach((cell, colIdx) => {
                var colId = colIds[colIdx],
                    contentEl = cell.children[0];

                cell.dataset.rowId = rowId;
                cell.dataset.colId = colId;

                this.cellDelegate.renderCell({sectionId, trackContentSizes, rowId, colId, dragColId, contentEl});
            });
        });
    },

    setScrollFrameTrackCounts({rowCount, colCount}) {
        var sectionId = this.sectionId;

        SA.view.CountAdjuster.create()
            .currentCount(this.scrollFrameEl.rows.length)
            .targetCount(rowCount)
            .incrementFn(() => this.scrollFrameEl.insertRow(-1))
            .decrementFn(() => this.scrollFrameEl.deleteRow(-1))
            .apply();

        Array.from(this.scrollFrameEl.rows).forEach(row => {
            SA.view.CountAdjuster.create()
                .currentCount(row.cells.length)
                .targetCount(colCount)
                .incrementFn(() => {
                    var cell = row.insertCell(-1),
                        contentEl = cell.appendChild(document.createElement('div'));

                    this.cellDelegate.initCell({sectionId, contentEl});
                })
                .decrementFn(() => row.deleteCell(-1))
                .apply();
        });
    }
});